import { render } from "./EnvelopeSimple.vue?vue&type=template&id=6e73dda0"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/EnvelopeSimple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e73dda0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e73dda0', __exports__)) {
    api.reload('6e73dda0', __exports__)
  }
  
  module.hot.accept("./EnvelopeSimple.vue?vue&type=template&id=6e73dda0", () => {
    api.rerender('6e73dda0', render)
  })

}


export default __exports__